/*
 * @Author: hujingyang
 * @Date: 2021-01-21 15:54:28
 * @Description: 短信充值记录
 * @LastEditors: yang chenglin
 * @LastEditTime: 2021-05-13 10:57:28
 * @FilePath: \DouYinStore\src\pages\AccountKeeper\components\SMSPaymentRecord\index.tsx
 * @IDE: Created by VScode.
 */


import React, { useEffect, useState } from 'react';
import { Balloon, Button, Icon, Loading, Table } from '@alifd/next';
import style from './index.module.scss';
import LzPagination from '@/components/common/LzPagination';
import utils from '@/common/utils';
import { Servlets } from '@/service';
import LzMsg from '@/components/common/LzMsg';
import moment from 'moment';

/** 短信充值记录 */
const SMSPaymentRecord = (): JSX.Element => {
  const [isLoading, setLoading] = useState(false);// 是否正在加载页面数据
  const [isLoadingForList, setLoadingForList] = useState(false);// 是否正在加载列表数据
  const [dataSource, setDataSource] = useState([{}]);// 列表数据
  const [pageInfo, setPageInfo] = useState({ pageNo: 1, pageSize: 10, total: 0 }); // 分页数据


  /** 生命周期函数 */
  useEffect(() => {
    init();
  }, []);

  /** 初始化函数 */
  const init = (): void => {
    setLoading(true);

    setDataSource(getDataSource({ pageNo: 1, pageSize: 10 }));


    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  /** 列表元数据（mock） */
  const getDataSource = (v) => {
    // 获取列表数据
    Servlets('getPaymentRecord', {
      pageNo: v.pageNo,
      pageSize: v.pageSize,
      endTime: '',
      startTime: '',
      status: '',
    }).then((res) => {
      setDataSource(res.data);
      setPageInfo({
        ...pageInfo,
        pageNo: res.page.pageNo,
        pageSize: res.page.pageSize,
        total: res.page.total,
      });
    });
  };


  // /** 获取 列表数据格式配置项 */
  // const getColumns = (): Array<object> => {
  //   const columns = [
  //     {
  //       title: "订单号",
  //       dataIndex: "order",
  //       width: 180,
  //       alignHeader: 'left',
  //       align: 'left'
  //     },
  //     {
  //       title: "充值日期",
  //       dataIndex: "date",
  //       width: 180,
  //       alignHeader: 'left',
  //       align: 'left'
  //     },
  //     {
  //       title: "充值金额",
  //       dataIndex: "salary",
  //       width: 180,
  //       alignHeader: 'left',
  //       align: 'left',
  //       cell: (value: number, index: number, record: object) => { return <span>{utils.numFormat_hjy(value)}</span> }
  //     },
  //     {
  //       title: "充值短信条数",
  //       dataIndex: "num",
  //       width: 180,
  //       alignHeader: 'left',
  //       align: 'left',
  //       cell: (value: number, index: number, record: object) => { return <span>{utils.numFormat_hjy(value)}</span> }
  //     },
  //     {
  //       title: "充值状态",
  //       dataIndex: "status",
  //       width: 180,
  //       alignHeader: 'left',
  //       align: 'left',
  //       cell: (value: number, index: number, record: object) => {
  //         return <div>
  //           {/* status [-1付款失败] [0 等待付款] [1付款成功]*/}
  //           {value === 0 && <span style={{ color: "#FF9900" }}>等待付款</span>}
  //           {value === 1 && <span style={{ color: "#00BB66" }}>付款成功</span>}
  //           {value === -1 &&

  //             <Balloon popupClassName="popupClassName" trigger={<span style={{ color: "##FF3333", display: 'flex', alignItems: 'center', cursor: 'pointer' }}>付款失败<Icon type="prompt" size="small" style={{ color: '#E3E8EE', marginLeft: 4 }} /></span>} closable={false}>
  //               为什么会付款失败呢？
  //                    </Balloon>


  //           }
  //         </div>
  //       }
  //     },
  //     {
  //       title: "操作",
  //       lock: 'right',
  //       width: 180,
  //       alignHeader: 'left',
  //       align: 'left',
  //       cell: (value: number, index: number, record: { status: number }) => {
  //         return <div style={{ userSelect: 'none' }}>
  //           {/* status [-1付款失败] [0 等待付款] [1付款成功]*/}
  //           {record.status === 0 && <Button type="primary" text onClick={() => { }}>去付款</Button>}
  //           {record.status === 1 && <span>- -</span>}
  //           {record.status === -1 && <span style={{ color: '#C3CBD6' }}>去付款</span>}
  //         </div>
  //       }
  //     },
  //   ];
  //   return columns;
  // }


  /**
   * 翻页方法
   */
  const handlePageSizeChange = async (pages: object = {}): Promise<void> => {
    // console.log(pages)
    setLoadingForList(true);
    // setTimeout(() => {
    //   setLoadingForList(false);
    // }, 500);
    try {
      setPageInfo({
        ...pageInfo,
        ...pages,
      });
      getDataSource({ pageSize: pages.pageSize, pageNo: pages.pageNo });
      setLoadingForList(false);
    } catch (e) {
      LzMsg.error(e.message);
    }
  };


  return (
    <>
      <Loading visible={isLoading} fullScreen>
        {

          <div className={style.SMSPaymentRecord}>
            <div className={style.mainBox}>
              <div className={style.formAndListStyle}>
                {/* 列表 */}
                <div className={style.listContent}>
                  <div style={{ marginTop: 8 }}>
                    <Table
                      dataSource={dataSource}
                      fixedHeader
                      maxBodyHeight={460}
                      loading={isLoadingForList}
                    >
                      <Table.Column
                        title="充值日期"
                        dataIndex="createTime"
                        align="left"
                        cell={(value, index, record) => {
                          return <span>{moment(record.createTime).format('YYYY-MM-DD HH:mm:ss')}</span>;
                        }}
                      />
                      <Table.Column
                        title="充值金额"
                        align="left"
                        cell={(value, index, record) => {
                          return <span>{utils.numFormat_hjy(record.fee)}</span>;
                        }}
                      />
                      <Table.Column
                        title="充值短信条数"
                        align="left"
                        cell={(value, index, record) => {
                          return <span>{utils.numFormat_hjy(record.count)}</span>;
                        }}
                      />
                      <Table.Column
                        title="充值状态"
                        align="left"
                        cell={(value, index, record) => {
                          return (<div>
                            {/* status [-1付款失败] [0 等待付款] [1付款成功] */}
                            {record.status === 0 &&
                            <span style={{ color: '#FF9900' }}>等待付款</span>}
                            {record.status === 1 &&
                            <span style={{ color: '#00BB66' }}>付款成功</span>}
                            {record.status === -1 &&
                            <Balloon
                              popupClassName="popupClassName"
                              trigger={<span style={{
                                color: '##FF3333',
                                display: 'flex',
                                alignItems: 'center',
                                cursor: 'pointer',
                              }}
                              >付款失败
                                <Icon type="prompt" size="small" style={{ color: '#E3E8EE', marginLeft: 4 }} />
                              </span>}
                              closable={false}
                            >
                              为什么会付款失败呢？
                            </Balloon>

                          }
                                  </div>);
                        }}
                      />
                      <Table.Column
                        title="备注"
                        align="left"
                        dataIndex="payRemark"
                      />
                      <Table.Column
                        title="操作"
                        align="left"
                        cell={(value, index, record) => {
                          return (<div style={{ userSelect: 'none' }}>
                            {/* status [-1付款失败] [0 等待付款] [1付款成功] */}
                            {record.status === 0 && <Button
                              type="primary"
                              text
                              onClick={() => {
                                window.open(`./accountKeeper/sms/payDeal/ali/${record.fee / record.count}/${record.count}/2`, '_blank'); // 2代表不是首充
                              }}
                            >去付款
                            </Button>}
                            {record.status === 1 && <span>- -</span>}
                            {record.status === -1 &&
                            <span style={{ color: '#C3CBD6' }}>去付款</span>}
                                  </div>);
                        }}
                      />
                    </Table>
                  </div>

                  <div className={[style.Pagination, 'Hjy-Pagination'].join(' ')}>
                    <LzPagination pageInfo={pageInfo} onChange={handlePageSizeChange} />
                  </div>
                </div>
              </div>

            </div>


          </div>

        }
      </Loading>

    </>
  );
};

export default SMSPaymentRecord;
